const checkoutBtn = document.querySelector<HTMLAnchorElement>(
  '#shopping-cart-checkout',
);
const removeBtns =
  document.querySelectorAll<HTMLAnchorElement>('.js-cart-remove');

if (checkoutBtn && removeBtns.length > 0) {
  checkoutBtn.addEventListener('click', (e) => {
    e.preventDefault();

    // A row renders one remove control per breakpoint, so keep one per product.
    const seen = new Set<string>();
    const uniqueBtns = Array.from(removeBtns).filter((btn) => {
      const productID = btn.dataset.productId;
      if (!productID || seen.has(productID)) return false;
      seen.add(productID);
      return true;
    });

    const items = uniqueBtns.map((btn) => {
      try {
        if (!btn.dataset.gtm) throw new Error('No data-gtm attribute');
        return JSON.parse(btn.dataset.gtm);
      } catch (error) {
        console.error('Error parsing GTM data:\n', error);
        return false;
      }
    });

    const value =
      document.querySelector<HTMLElement>('#shopping-cart-subtotal')?.dataset
        .gtmSubtotal || '0';

    if (globalThis.dataLayer) {
      globalThis.dataLayer.push({ ecommerce: null });
      globalThis.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: 'USD',
          items,
          value: parseFloat(value) || 0,
        },
      });
    }

    const href = (e.target as HTMLAnchorElement).getAttribute('href');

    if (!href) {
      console.error('No href attribute found on checkout button');
      return;
    }

    window.location.assign(href);
  });
}
